var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 113,
    viewBox: "0 0 124 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6896 18.1474C61.6151 -5.28006 32.6746 -4.53411 18.4905 11.8733C-2.11464 35.7083 -14.9335 78.1343 32.6746 101.114C112.07 139.438 141.839 66.2595 113.519 57.2433C85.1979 48.2272 84.8323 30.802 76.6896 18.1474Z",
    fill: "#F5F5FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_804_12915",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 113
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6545 18.1474C61.5869 -5.28006 32.6596 -4.53411 18.482 11.8733C-2.11367 35.7083 -14.9267 78.1343 32.6596 101.114C112.019 139.438 141.774 66.2595 113.467 57.2433C85.1589 48.2272 84.7934 30.802 76.6545 18.1474Z",
    fill: "#F5F5FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_804_12915)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5441 61.2372C51.1653 61.2372 53.2096 54.5075 56.4032 50.8144C58.6881 48.1721 62.5878 48.96 63.7421 45.2608C66.6447 35.9588 58.8759 29.4119 48.741 29.4119C38.6061 29.4119 31.7726 35.1537 30.2971 43.7853C28.8216 52.4168 35.4092 61.2372 45.5441 61.2372Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9062 60.026C55.0912 61.9458 58.2205 62.8733 59.6895 62.4946C63.373 61.5452 63.7117 48.0698 60.8616 42.7574C58.0115 37.445 43.3595 35.1295 42.621 45.6551C42.3647 49.3082 43.8986 52.5683 46.1649 55.2286L42.1012 74.1692H53.9053L51.9062 60.026Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3882 38.265C34.3467 47.1181 43.4228 56.5278 45.9096 56.5278C46.0701 55.2505 46.5598 54.008 47.2773 52.8253C46.8962 52.3318 46.6704 51.718 46.6704 51.0528C46.6704 49.423 48.0261 48.1018 49.6985 48.1018C50.2208 48.1018 50.7122 48.2307 51.1411 48.4576C54.766 45.3661 59.3123 43.211 61.5697 42.7872C65.496 42.0502 52.4298 29.4119 43.3882 38.265Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4028 120.775L81.4701 107.183L76.8425 115.19L91.3307 123.732C94.9635 129.454 97.0971 131.927 97.7315 131.149C98.2664 130.494 98.0213 129.776 97.7955 129.114C97.6195 128.598 97.4554 128.117 97.6808 127.727C98.1957 126.836 101.105 127.346 103.844 127.949C106.584 128.551 105.95 127.205 105.368 126.503C102.778 124.413 99.4568 122.504 95.4028 120.775ZM13.2784 140.522C14.7198 137.598 19.6281 109.099 19.6281 109.099L29.9062 109.14C29.9062 109.14 20.3868 139.87 19.6281 141.75C18.6425 144.193 20.3167 147.742 21.4519 150.148C21.6275 150.521 21.7902 150.866 21.9282 151.175C20.353 151.88 19.5964 151.028 18.7986 150.13C17.8976 149.115 16.9442 148.042 14.6998 149.086C13.8327 149.489 13.0122 149.966 12.2106 150.432C9.44155 152.042 6.89777 153.52 3.4373 151.385C2.88869 151.046 2.2875 149.772 3.74005 148.776C7.35887 146.295 12.5738 141.952 13.2784 140.522Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8369 65.9712L53.0899 65.2418C60.4121 83.5333 73.196 100.154 91.4416 115.102L77.6543 131.853C59.4109 110.567 48.1656 88.607 48.8369 65.9712Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2971 119.418H68.1686C68.1686 119.418 55.0077 87.4182 55.0077 65.0509L43.5837 63.3487C34.6055 77.7883 32.07 95.5664 30.2971 119.418Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3418 63.3568L43.3327 63.3488C43.3327 63.3488 17.2244 88.9223 13.0827 135.649H31.5417C31.3916 133.591 31.2983 131.558 31.2561 129.553H56.0453C56.0453 129.553 51.3677 85.8308 50.9297 71.4035L48.1693 63.5148C48.1693 63.5148 45.4305 63.3948 44.092 63.3487H43.3463C43.3448 63.3514 43.3433 63.3541 43.3418 63.3568Z",
    fill: "#2F3676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2603 129.747C31.0625 121.017 31.837 112.82 33.1289 105.402C33.8047 114.204 35.2169 124.796 38.1665 129.747H31.2603Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7455 114.5L48.9869 108.809V114.5H36.7455Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalImg);
export default __webpack_public_path__ + "static/media/modal-img.a95b552642edca7fa13f4d49a974da0b.svg";
export { ForwardRef as ReactComponent };